export const crewRateList = (state) => state.crewRateList;
